import fns from './functions'
// import ps from "perfect-scrollbar"

$(function(){
  fns.sizer();
  fns.touchHover();
  fns.breakPoint();
  fns.uaCheck();
  fns.exLink();
});

$(window).on('load resize orientationchange', function(){
  fns.sizer();
  fns.breakPoint();
});

$(function(){

  // purl
  //------------------------------------------------------------
  var bodyclass = $.url().param("bodyclass");
  $("body").addClass(bodyclass);

  var bodyid = $.url().param("bodyid");
  $("body").attr("id", bodyid);

  var purl = $.url().param("purl");
  $("html").attr("class", purl);

  if( $.url().param("debug") == "ssi" ) {
    $("html").addClass("debug-ssi")
  }

  // // perfect-scrollbar
  // //------------------------------------------------------------
  // var side = $(".layout__side").get(0);
  // ps.initialize(side, {
  //   // wheelSpeed: 2,
  //   // wheelPropagation: true,
  //   // minScrollbarLength: 0
  // });

  // footer__loading
  //------------------------------------------------------------
  $(window).on('load', function(){
    setTimeout(function(){
      $("html").addClass("is-loaded");
    }, 500);
  });

  // js-ps-bar
  //------------------------------------------------------------
  // $(".js-ps-bar").perfectScrollbar();

});



// WEBPACK FOOTER //
// ./_src/js/util/ready.js